import { render, staticRenderFns } from "./ConfirmDialogPosPageAddClient.vue?vue&type=template&id=000b3615"
import script from "./ConfirmDialogPosPageAddClient.vue?vue&type=script&lang=js"
export * from "./ConfirmDialogPosPageAddClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports